import React, { Fragment } from 'react';
import { Navigate, useOutlet } from 'react-router-dom';
import { useSessionStorage } from '../../hooks';
import { setUnauthenticated } from '../../utils/auth';

export const AuthRoute = () => {
  const outlet = useOutlet();
  const [authenticated] = useSessionStorage('authenticated');

  if (!authenticated) {
    setUnauthenticated();
    return <Navigate to='/home' replace />;
  }
  return <Fragment>{outlet}</Fragment>;
};
